import { createBrowserRouter, Navigate } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { AdminLayout } from './layout/AdminLayout';
import { TenantsPage } from '@/pages/tenants/TenantsPage';
import { TenantDetailPage } from '@/pages/tenant-detail/TenantDetailPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AdminLayout />,
    children: [
      { index: true, element: <Navigate to="/tenants" replace /> },
      { path: 'tenants', element: <TenantsPage /> },
      { path: 'tenants/:tenantId', element: <TenantDetailPage /> },
      { path: '*', element: <Navigate to="/tenants" replace /> },
    ],
  },
]);

export function AdminRouter() {
  return <RouterProvider router={router} />;
}
